import {Voucher} from "./components/Voucher";

export const EcommerceVoucher = () => {
    return (
        <Voucher/>
    );
};